export function filtrarLabelTodosFiltros(arr: TStateObjFiltros[]): TStateObjFiltros[] {
    const ultimoItem = arr[arr.length - 1];

    if (ultimoItem.nome.toLowerCase() === "todas" || ultimoItem.nome.toLowerCase() === "todos") {
        return [ultimoItem];
    } else {
        return arr.filter(item => item.nome.toLowerCase() !== "todas" && item.nome.toLowerCase() !== "todos");
    }
}

export type TStateObjFiltros = {
    id: number | null,
    nome: string
}